import { create } from "zustand";

const initialState = {
  isOpen: false,
  challengeId: null,
  code: "",
  error: null,
  isLoading: false,
};

/**
 * Global OTP step-up state. The axios response interceptor in
 * redux/network/https.js opens this store when the backend answers
 * 403 { code: "otp_required" }; SecurityOtpModal renders it.
 *
 * `resolver` holds the pending request's { resolve, reject } callbacks —
 * resolve() retries the original request, reject() abandons it (user cancel).
 */
export const useSecurityOtpStore = create((set, get) => ({
  ...initialState,
  resolver: null,

  open: (challengeId, resolver) =>
    set({ ...initialState, isOpen: true, challengeId, resolver }),

  setCode: (code) => set({ code, error: null }),

  setError: (error) => set({ error, isLoading: false }),

  setLoading: (isLoading) => set({ isLoading }),

  // Resolve the pending request and reset (called after a successful verify)
  resolvePending: () => {
    get().resolver?.resolve();
    get().close();
  },

  // Reject the pending request and reset (user cancelled the step-up)
  rejectPending: () => {
    get().resolver?.reject();
    get().close();
  },

  close: () => set({ ...initialState, resolver: null }),
}));
